export default __webpack_public_path__ + "static/media/figma1.2aef9b29.gif";